/**
 * @generated SignedSource<<74b37e44b13fb843c4a420b9c1a14ae8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateSegmentInput = {
  clientMutationId?: string | null;
  condition?: any | null;
  quota?: number | null;
  segmentId: string;
  terminate?: boolean | null;
  text?: string | null;
};
export type Segment_UpdateSegment_Mutation$variables = {
  input: UpdateSegmentInput;
};
export type Segment_UpdateSegment_Mutation$data = {
  readonly updateSegment: {
    readonly segment: {
      readonly text: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"Segment_segment">;
    } | null;
  } | null;
};
export type Segment_UpdateSegment_Mutation = {
  response: Segment_UpdateSegment_Mutation$data;
  variables: Segment_UpdateSegment_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Segment_UpdateSegment_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateSegmentPayload",
        "kind": "LinkedField",
        "name": "updateSegment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SegmentNode",
            "kind": "LinkedField",
            "name": "segment",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Segment_segment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Segment_UpdateSegment_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateSegmentPayload",
        "kind": "LinkedField",
        "name": "updateSegment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SegmentNode",
            "kind": "LinkedField",
            "name": "segment",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "condition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quota",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "terminate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5128cb2fb048c8b10ec026b4016d486e",
    "id": null,
    "metadata": {},
    "name": "Segment_UpdateSegment_Mutation",
    "operationKind": "mutation",
    "text": "mutation Segment_UpdateSegment_Mutation(\n  $input: UpdateSegmentInput!\n) {\n  updateSegment(input: $input) {\n    segment {\n      text\n      ...Segment_segment\n      id\n    }\n  }\n}\n\nfragment Segment_segment on SegmentNode {\n  id\n  condition\n  text\n  quota\n  count\n  terminate\n}\n"
  }
};
})();

(node as any).hash = "dae4c396f0887e1efcaa224a69d04ace";

export default node;
